import { OneAuthCallback, LogPayload, AuthPayload } from '@chegg/one-auth'
import { useSelector } from 'react-redux'
import { login } from '@chegg-wt/core/state/user/actions'
import { AuthSuccessGrant } from '@chegg-wt/core/state/user/logics'
import {
  ClickstreamSignInSuccess1,
  ClickstreamSignUpSuccess1,
} from '@chegg/one-auth/dist/types/lib/rio/eventSchemas'
import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { AuthModalData } from '@chegg-wt/core/components/Modals/AuthModal/types'

const useOneAuthCallback = (setAuthSuccess, dispatch) => {
  const { redirectTo } = useSelector(modalDataSelector) as AuthModalData

  const callback: OneAuthCallback = (params) => {
    let auth_method
    const { type, payload } = params
    switch (type) {
      case 'log': {
        const { data, type } = payload as LogPayload

        switch (type) {
          case 'clickstream_sign_in_success':
            auth_method = (data as ClickstreamSignInSuccess1).sign_in.auth_service
            break
          case 'clickstream_sign_up_success':
            auth_method = (data as ClickstreamSignUpSuccess1).sign_up.auth_service
            break
          default:
        }
        break
      }
      case 'auth': {
        const { status, data, action } = payload as AuthPayload
        switch (status) {
          case 'success': {
            if (action === 'reset_password') break
            const successResponse: AuthSuccessGrant = {
              id_token: data.idToken,
              access_token: data.accessToken,
              auth_method,
            }
            dispatch(login(successResponse, redirectTo))
            setAuthSuccess(true)
            break
          }
          default: {
            break
          }
        }
        break
      }
      default: {
        break
      }
    }
  }

  return callback
}

export default useOneAuthCallback
